import { Customer, CustomerStatus, ProjectRequest } from "~/gql/types";

type RequestCustomerInfo = {
  customer: Customer;
  customerNumber: string;
  buttonText: string;
};

export const getCustomerInfo = (
  projectRequest: ProjectRequest
): RequestCustomerInfo => {
  const customer = projectRequest.customer!;

  let customerNumber: string;
  let buttonText: string;
  switch (customer!.status) {
    case CustomerStatus.Approved:
      customerNumber = customer?.number ?? "";
      buttonText = "Approve";
      break;
    case CustomerStatus.Pending:
      customerNumber = "(Pending)";
      buttonText = "Approve With Pending Customer";
      break;
    case CustomerStatus.InProjectRequest:
      customerNumber = "(New Request)";
      buttonText = "Approve With Customer Request";
      break;
    default:
      customerNumber = "";
      buttonText = "";
  }

  return {
    customer,
    customerNumber,
    buttonText,
  };
};
